import { screenSize } from '@app/styles';
import styled from 'styled-components';

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 50px);
  width: 100%;
  margin-top: 50px;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
    display: block;
    margin-top: 56px;
    height: calc(100vh - 56px);
  }
`;
